import { map, mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { absencesService } from '../../../common/services';
import * as actionTypes from './actionTypes';
import * as absencesActions from './actions';

export function fetchCarerStudents(action$) {
  return action$.pipe(
    ofType(actionTypes.FETCH_CARER_STUDENTS),
    mergeMap(({ payload }) => {
      return absencesService.getCarerStudents(payload)
        .pipe(
          map(res => absencesActions.fetchCarerStudentsSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}
export function fetchAbsences(action$) {
  return action$.pipe(
    ofType(actionTypes.FETCH_ABSENCES),
    mergeMap(({ payload }) => {
      return absencesService.getAbsences(payload)
        .pipe(
          map(res => absencesActions.fetchAbsencesSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}
export function fetchAbsencePercentage(action$) {
  return action$.pipe(
    ofType(actionTypes.FETCH_ABSENCE_PERCENTAGE),
    mergeMap(({ payload }) => {
      return absencesService.fetchAbsencePercentage(payload)
        .pipe(
          map(res => absencesActions.fetchAbsencePercentageSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}
export function fetchStudentInfo(action$) {
  return action$.pipe(
    ofType(actionTypes.FETCH_STUDENT_INFO),
    mergeMap(({ payload }) => {
      return absencesService.fetchStudentInfo(payload)
        .pipe(
          map(res => absencesActions.fetchStudentInfoSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}
export function sendAbsentEmail(action$) {
  return action$.pipe(
    ofType(actionTypes.SEND_ABSENT_EMAIL),
    mergeMap(({ payload }) => {
      return absencesService.sendAbsentEmail(payload)
        .pipe(
          map(res => absencesActions.sendAbsentEmailSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}
export function saveAbsenceReason(action$) {
  return action$.pipe(
    ofType(actionTypes.SAVE_ABSENCE_REASON),
    mergeMap(({ payload }) => {
      return absencesService.saveAbsenceReason(payload)
        .pipe(
          map(res => absencesActions.saveAbsenceReasonSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}
